export default __webpack_public_path__ + "static/media/img4.88346753.png";